import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useLegacyCalculatorAccessQuery } from "web_myplann/Api/Calculators/useLegacyCalculatorAccessQuery";
import { useOpenCalculator } from "web_myplann/Calculators/Hooks/useOpenCalculator";
import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import { DashboardPicturedRow } from "web_myplann/Dashboard/Components/DashboardPictureRow";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import mortgageImg from "web_myplann/Shared/Assets/mortgage.png";
import travelImg from "web_myplann/Shared/Assets/travel.png";

const PageResources = Resources.Dashboard.ImageCard;

export const DashboardImageCardSection: FC = () => {
	const { t } = useResource();
	const { data: access, isLoading: isAccessLoading } =
		useLegacyCalculatorAccessQuery();
	const { openCalculator, isOpeningCalculator } = useOpenCalculator();

	return (
		<Stack px={1.6} pt={1.6}>
			{!isAccessLoading && (
				<Typography variant="deprecatedH3">{t(PageResources.title)}</Typography>
			)}
			{isAccessLoading ? (
				<Stack pt={1.2}>
					<DashboardSkeleton height={80} count={2} />
				</Stack>
			) : (
				<Stack
					alignItems="center"
					pt={1.2}
					gap={1.2}
					data-testid="dashboard-image-card"
				>
					<DashboardPicturedRow
						title={t(PageResources.Mortgage.title)}
						description={t(PageResources.Mortgage.description)}
						imageSrc={mortgageImg}
						onClick={() => openCalculator(CalculatorType.Mortgage)}
						disabled={!access?.mortgage.hasAccess || isOpeningCalculator}
					/>
					<DashboardPicturedRow
						title={t(PageResources.Travel.title)}
						description={t(PageResources.Travel.description)}
						imageSrc={travelImg}
						onClick={() => openCalculator(CalculatorType.TravelInsurance)}
						disabled={!access?.travelInsurance.hasAccess || isOpeningCalculator}
					/>
				</Stack>
			)}
		</Stack>
	);
};
